import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'ness-administration',
  templateUrl: './administration.component.html',
  providers: [DialogService]
})
export class AdministrationComponent implements OnInit {

  activeIndex: number = 0;
  constructor(private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private router: Router) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.activeIndex = parseInt(params['tabIndex']) || 0;
    });
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  onChangeTab(e: { originalEvent: Event, index: number}) {
    this.activeIndex = e.index || 0;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.route.snapshot.queryParams,
        tabIndex: this.activeIndex,
      }
    });
  }
}
